module.exports = __webpack_public_path__ + "static/polar-hero-4bd179be54305a2dd60553dea121937d.jpg";